import React, { useMemo, useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { SET_SELECTED_BUSINESS, UPDATE_BUSINESS_ID } from "../store/constants/Constants";
import { Text } from "../custom-components";
import { IcChevronDown, IcChevronUp, IcBuilding } from "../custom-components/Icon";

const BusinessGroupSelector = () => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const businesses = useSelector((state) => state.common.businesses);
  const selectedBusiness = useSelector((state) => state.common.selectedBusiness);
  const userOriginalBusinessId = useSelector((state) => state.common.user_original_business_id);
  const tenantId = useSelector((state) => state.common.tenant_id);

  const filteredBusinesses = useMemo(() => {
    if (!businesses || businesses.length === 0) return [];
    const isSuperAdmin = userOriginalBusinessId === tenantId;
    if (isSuperAdmin) {
      return businesses;
    } else {
      return businesses.filter(b => b.businessId === userOriginalBusinessId);
    }
  }, [businesses, userOriginalBusinessId, tenantId]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleBusinessChange = (selectedId) => {
    dispatch({
      type: SET_SELECTED_BUSINESS,
      payload: selectedId,
    });
    dispatch({ type: UPDATE_BUSINESS_ID, payload: selectedId });
    setIsOpen(false);
  };

  if (!filteredBusinesses || filteredBusinesses.length === 0) return null;

  const selectedBusinessObj = filteredBusinesses.find(b => b.businessId === selectedBusiness);
  const selectedBusinessName = selectedBusinessObj?.name || "Select a business";

  return (
    <div style={{ display: 'flex', alignItems: 'center', margin: 0, padding: '0 8px' }}>
      <div ref={dropdownRef} style={{ position: 'relative', minWidth: '360px' }}>
        <div 
          onClick={() => setIsOpen(!isOpen)}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '6px 12px',
            border: '1px solid #e5e7eb',
            borderRadius: '20px',
            backgroundColor: '#ffffff',
            cursor: 'pointer',
            minHeight: '36px',
            boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {selectedBusinessObj?.logo ? (
              <img src={selectedBusinessObj.logo} alt="Business Logo" style={{ width: '16px', height: '16px', objectFit: 'contain', borderRadius: '2px' }} />
            ) : (
              <div style={{ width: '16px', height: '16px', borderRadius: '50%', backgroundColor: '#0d9488', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: '9px', fontWeight: 'bold' }}>
                {selectedBusinessName.charAt(0).toUpperCase()}
              </div>
            )}
            <Text appearance="body-xs-bold" style={{ color: '#111827', fontSize: '13px', fontWeight: '600' }}>
              {selectedBusinessName}
            </Text>
          </div>
          {isOpen ? <IcChevronUp height={16} width={16} style={{ color: '#6b7280' }} /> : <IcChevronDown height={16} width={16} style={{ color: '#6b7280' }} />}
        </div>
        {isOpen && (
          <div style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            minWidth: '100%',
            whiteSpace: 'nowrap',
            marginTop: '4px',
            backgroundColor: '#fff',
            border: '1px solid #d1d5db',
            borderRadius: '4px',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
            zIndex: 100,
            maxHeight: '250px',
            overflowY: 'auto'
          }}>
            <div style={{ padding: '8px 12px 4px 12px', marginBottom: '4px' }}>
              <Text appearance="body-xs" style={{ color: '#6b7280', fontSize: '10px', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                Business Group
              </Text>
            </div>
            {filteredBusinesses.map(b => (
              <div
                key={b.businessId}
                onClick={() => handleBusinessChange(b.businessId)}
                style={{
                  padding: '6px 8px',
                  cursor: 'pointer',
                  fontSize: '11px',
                  fontWeight: selectedBusiness === b.businessId ? '600' : 'normal',
                  color: selectedBusiness === b.businessId ? '#111827' : '#4b5563',
                  backgroundColor: selectedBusiness === b.businessId ? '#f3f4f6' : '#fff'
                }}
                onMouseOver={(e) => {
                  if (selectedBusiness !== b.businessId) e.currentTarget.style.backgroundColor = '#f3f4f6';
                }}
                onMouseOut={(e) => {
                  if (selectedBusiness !== b.businessId) e.currentTarget.style.backgroundColor = '#fff';
                }}
              >
                {b.name}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default BusinessGroupSelector;
